import * as React from 'react'
import type { SVGProps } from 'react'
const OutlineSearch = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.3402 3C17.0136 3 20.8021 6.78856 20.8021 11.462C20.8021 16.1354 17.0136 19.924 12.3402 19.924C10.3555 19.924 8.53039 19.2407 7.08727 18.0966L4.37896 20.7979C4.10825 21.0679 3.6699 21.0673 3.39989 20.7966C3.12988 20.5259 3.13045 20.0875 3.40116 19.8175L6.07529 17.1504C4.71015 15.6478 3.87818 13.652 3.87818 11.462C3.87818 6.78856 7.66673 3 12.3402 3ZM19.4175 11.462C19.4175 7.55326 16.2489 4.38462 12.3402 4.38462C8.43144 4.38462 5.26279 7.55326 5.26279 11.462C5.26279 15.3707 8.43144 18.5393 12.3402 18.5393C16.2489 18.5393 19.4175 15.3707 19.4175 11.462Z" fill="#5B5B5B"/>
    </svg>
  )
}

export default OutlineSearch
